












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component({
    name: 'ScheduleBoard',
    components: {},
})
export default class Guideline extends Vue {
    // @PropSync('isVisible') public visible!: boolean;
    @Prop() public visible!: boolean;
    @Prop() public steps!: GuidelineStep[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('hideGuideline', { namespace: 'workshopsSchedule' }) private hideGuideline: any;
    @Action('showGuideline', { namespace: 'workshopsSchedule' }) private showGuideline: any;
    @Getter('isGuidelineVisible', { namespace: 'workshopsSchedule' }) private isGuidelineVisible!: boolean;

    private get currentStep(): GuidelineStep {
        if (this.guidelineSteps && this.guidelineSteps.length > 0) {
            return this.guidelineSteps[this.currentStepIndex];
        } else {
            return {
                Title: '<b>Deafult Title</b>',
                Message: 'Default message.',
                CloseButtonAction: undefined,
                PrevButtonAction: () => {
                    this.currentStep.Message = 'Previous message';
                    return;
                },
                NextButtonAction: () => {
                    this.currentStep.Message = 'Next message';
                    return;
                },
            };
        }
    }

    private isVisible = true;
    private currentStepIndex = 0;

    private mounted() {
        if (this.currentStep && this.currentStep.OnLoad) this.currentStep.OnLoad();
    }

    private get isAlertVisible(): boolean {
        return this.isGuidelineVisible;
        // if (this.isVisible === undefined && this.visible === undefined) {
        //     return false;
        // }

        // return this.visible !== undefined ? this.visible && this.isVisible : this.isVisible;
    }

    private get isFirstStep(): boolean {
        return this.currentStepIndex <= 0 || this.guidelineSteps.length < 2;
    }

    private get isLastStep(): boolean {
        return this.currentStepIndex >= this.guidelineSteps.length - 1 || this.guidelineSteps.length < 2;
    }

    private get title(): string {
        return this.currentStep && this.currentStep.Title ? this.currentStep.Title.toString() : '';
    }

    private get message(): string {
        return this.currentStep && this.currentStep.Message ? this.currentStep.Message.toString() : '';
    }

    private get guidelineSteps(): GuidelineStep[] {
        return this.steps ? this.steps : [];
    }

    private closeButtonAction() {
        this.hideGuideline();
        if (this.currentStep.CloseButtonAction) {
            this.currentStep.CloseButtonAction();
        }
    }

    private prevButtonAction() {
        if (this.currentStep.PrevButtonAction) {
            this.currentStep.PrevButtonAction();
        }

        if (this.currentStepIndex > 0) {
            this.currentStepIndex--;
            if (this.currentStep.OnLoad) {
                this.currentStep.OnLoad();
            }
        }
    }

    private nextButtonAction() {
        if (this.currentStep.NextButtonAction) {
            this.currentStep.NextButtonAction();
        }

        if (this.currentStepIndex < this.guidelineSteps.length - 1) {
            this.currentStepIndex++;
            if (this.currentStep.OnLoad) {
                this.currentStep.OnLoad();
            }
        }
    }
}

export class GuidelineStep {
    Title? = '';
    Message? = '';
    OnLoad? = () => {
        return;
    };
    CloseButtonAction? = () => {
        return;
    };
    PrevButtonAction? = () => {
        return;
    };
    NextButtonAction? = () => {
        return;
    };
}
